import { api } from './client'

// ─── Participant-facing ─────────────────────────────────────────────────────
export const getTest = (pid, kind) =>
  api.get(`/tests/programs/${pid}/${kind}`).then((r) => r.data)
export const submitTest = (pid, kind, answers) =>
  api.post(`/tests/programs/${pid}/${kind}/submit`, { answers }).then((r) => r.data)
export const getLearningGain = (pid) =>
  api.get(`/tests/programs/${pid}/learning-gain`).then((r) => r.data)
export const getTestNotifications = (pid) =>
  api.get(`/tests/programs/${pid}/notifications`).then((r) => r.data)

// ─── Trainer / Admin authoring (FR-7.1) ─────────────────────────────────────
export const getAdminTest = (pid, kind) =>
  api.get(`/tests/programs/${pid}/${kind}/admin`).then((r) => r.data)
export const upsertTest = (pid, kind, data) =>
  api.post(`/tests/programs/${pid}/${kind}`, data).then((r) => r.data)
export const updateTest = (pid, kind, data) =>
  api.put(`/tests/programs/${pid}/${kind}`, data).then((r) => r.data)
export const deleteTest = (pid, kind) =>
  api.delete(`/tests/programs/${pid}/${kind}`).then((r) => r.data)
export const addTestQuestion = (pid, kind, data) =>
  api.post(`/tests/programs/${pid}/${kind}/questions`, data).then((r) => r.data)
export const updateTestQuestion = (qid, data) =>
  api.put(`/tests/questions/${qid}`, data).then((r) => r.data)
export const deleteTestQuestion = (qid) =>
  api.delete(`/tests/questions/${qid}`).then((r) => r.data)
// QR berisi tautan ke layar tes, untuk diproyeksikan ke kelas. Ada di /programs,
// bukan /tests, karena endpoint-nya melayani semua tujuan ?goto= dan URL-nya
// dibangun dari subdomain lembaga pemilik program.
export const getTestQr = (pid, kind) =>
  api.get(`/programs/${pid}/goto-qr`, { params: { target: kind } }).then((r) => r.data)

// ─── Reporting (FR-7.5) ─────────────────────────────────────────────────────
export const getCohortLearningGain = (pid, classId) =>
  api
    .get(`/tests/programs/${pid}/learning-gain/cohort`, {
      params: classId ? { class_id: classId } : undefined,
    })
    .then((r) => r.data)
export const getPendingGrading = (pid, classId) =>
  api
    .get(`/tests/programs/${pid}/attempts/pending-grading`, {
      params: classId ? { class_id: classId } : undefined,
    })
    .then((r) => r.data)

// ─── Penilaian esai oleh trainer (FR-7.4) ───────────────────────────────────
// Percobaan lengkap beserta soal dan jawaban peserta.
export const getAttempt = (attemptId) =>
  api.get(`/tests/attempts/${attemptId}`).then((r) => r.data)
// grades: { [questionId]: poinYangDiberikan }
export const gradeEssays = (attemptId, grades) =>
  api.post(`/tests/attempts/${attemptId}/grade-essays`, { grades }).then((r) => r.data)

// Trainer/admin mencatat skor pretest/posttest langsung — untuk peserta yang
// mengerjakan di luar sistem (kertas) atau tidak bisa mengakses aplikasi.
export const manualScoreTest = (pid, kind, userId, score) =>
  api.post(`/tests/programs/${pid}/${kind}/manual-score`, { userId, score }).then((r) => r.data)
